import React from "react";
import {useNavigate} from "react-router-dom";
import {usePutRegistrationByIdMutation} from "./reg_api";
import {FormikHelpers} from "formik";
import {FinishProps} from "./RegEditSchema";
import SnackError from "../../components/SnackError";
import {TablesUpdate} from "../../apitypes";
import RegForm, {RegData} from "./RegForm";
import {Box} from "@mui/material";

export default ({reg}: FinishProps) => {
    const navigate = useNavigate();
    const [saveRegistration, {error}] = usePutRegistrationByIdMutation({});
    const onSubmit = async function (values: RegData, helpers: FormikHelpers<any>) {
        const data: TablesUpdate<"registration"> = {
            WorkOrderID: values.workOrder?.id || null,
            WorkerID: values.worker?.id || null,
            MachineID: values.machine?.id || null,
            OperationID: values.workTask?.id || null,
            StartTime: values.StartTime,
            EndTime: values.EndTime || null,
            Status: reg.Status,
            ProductID: values.product?.id || null,
        }
        const res = await saveRegistration({id: reg.id, body: data});
        if ("data" in res) {
            navigate(-1);
            return
        }
        helpers.setSubmitting(false);
    }


    return <Box sx={{mt: "1em"}}>
        <SnackError error={error}/>
        <RegForm reg={reg} onSubmit={onSubmit} onCancel={() => navigate(-1)}/>
    </Box>
};


